import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnPL: CultureInfo = {
  name: 'en-PL',
  displayName: 'English (Poland)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-PL',
  parent: CultureInfoEn
};
